<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="exam_start flex flexcolumn Flexalign">
      <div class="exma_title flex Flexalign mt-30">
        <div class="flex Flexalign cursor_pointer" @click="goOnlineLearning">
          <!-- < -->
          <el-icon>
            <ArrowLeft />
          </el-icon>
          <div class="ml-5">返回</div>
        </div>
        <div class="exam_result ml-10 flex Flexalign">
          |
          <div class="ml-10">测评结果</div>
        </div>
      </div>
      <div class="my-30 exma_title exam_info">
        <div class="organization_info cursor_pointer flex Flexalign">
          <el-image class="gjkc_index_logo" :src="iconPath('gjkc_index_logo.png')"></el-image>
          <div class="ml-15">
            {{
              courseTypeList.filter((item) => item.value == selectCourseType)[0]?.label
            }}
          </div>
        </div>
        <div class="grade_analysis px-40 py-30" v-if="testPaperInfo.isCorrect != 2">
          <div class="grade_title">成绩分析</div>

          <div class="exam_result flex flexcolumn Flexalign">
            <div class="exam_name mt-40">{{ examInfo.examName }}</div>
            <div class="exam_desc mt-15">{{ examInfo.examDetail }}</div>
            <examScoreCharts ref="examScoreCharts" :value="getScorePercent(examInfo.score, examInfo.fullScore)"
              :score="examInfo.score" :totalScore="examInfo.fullScore"></examScoreCharts>
            <div class="split_line mt-15"></div>
            <div class="flex Flexalign FlexBetween exam_response mt-30">
              <div class="exam_response_one">
                <div class="response_label">考试开始时间</div>
                <div class="response_value mt-5">{{ testPaperInfo.startTime }}</div>
              </div>
              <div class="exam_response_one">
                <div class="response_label">考试结束时间</div>
                <div class="response_value mt-5">{{ testPaperInfo.endTime }}</div>
              </div>
              <div class="exam_response_one">
                <div class="response_label">考试用时</div>
                <div class="response_value mt-5">{{ $Tools.formatSecondsToTime(testPaperInfo.answerSection) }}</div>
              </div>
            </div>
            <div class="flex Flexalign FlexBetween exam_result_box mt-40">
              <div class="exam_result_one flex Flexalign FlexBetween cursor_pointer" @click="goRecordPaper">
                <div class="exam_result_left flex Flexalign ml-30">
                  <el-image class="exam_detail_icon" :src="iconPath('exam_detail_icon.png')"></el-image>
                  <div class="ml-15">试卷详情</div>
                </div>
                <el-icon class="mr-30">
                  <ArrowRight />
                </el-icon>
              </div>
              <!-- 仅能力测评有能力分析，考试没有 -->
              <div class="exam_result_one flex Flexalign FlexBetween cursor_pointer" @click="goExamAnalysis"
                v-if="testPaperType == 'testPaper'">
                <div class="exam_result_left flex Flexalign ml-30">
                  <el-image class="exam_detail_icon" :src="iconPath('ability_analysis_icon.png')"></el-image>
                  <div class="ml-15">能力分析</div>
                </div>
                <el-icon class="mr-30">
                  <ArrowRight />
                </el-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="empty_box" v-else>
          <el-image class="moe_empty_bg_img" :src="imgPath('exam_finish_empty_bg.png')"></el-image>
          <div class="empty_text">您的试卷已提交成功，请耐心等待批阅完成。</div>
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
import { mapState } from "vuex";
import examScoreCharts from "@/components/echarts/examScoreCharts.vue";
export default {
  name: "GjkcH5ExamFinish",
  components: { examScoreCharts },
  computed: {
    ...mapState({
      selectCourseType: (state) => state.user.selectCourseType,
      courseTypeList: (state) => state.filter.courseTypeList,
      currentExamCourseId: (state) => state.learning.currentExamCourseId,
    }),
  },
  watch: {
    selectCourseType: {
      handler(value) {
        this.gjkcTypeValue = value;
      },
      deep: true,
      immediate: true,
    },
  },

  data() {
    return {
      gjkcTypeValue: "",
      examInfo: {
        name: "练习卷3",
        desc: "测试描述测试描述测试描述测试描述测试描述",
        accuracyRate: 60,
        score: 60,
        totalScore: 100,
        startTime: "2025-09-01 11:13:16",
        endTime: "2025-09-01 11:13:16",
        useTime: "07:13:16",
      },
      recordId: {},
      courseId: "",
      testPaperType: '',
      testPaperInfo: {},
      loading: {},
    };
  },

  mounted() {
    this.recordId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).recordId;
    this.courseId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).courseId;
    this.testPaperType = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).testPaperType;
    this.loading = this.$Dialog.loading('获取试卷信息中，请耐心等待...');
    setTimeout(() => {
      if (this.testPaperType == 'testPaper') {
        this.getTestPaperRecord();
        this.testPaperCount();
      } else {
        this.getNewExamRecordInfo();
      }
    }, 200)
  },

  methods: {
    goOnlineLearning() {
      // this.href("/onlineLearning", { courseId: this.courseId });
      // this.$Jump.go(-1);
      if (this.testPaperType == 'testPaper') {
        this.$Jump.go(-4);
      } else {
        this.$store.commit("learning/setIsEnterExamList", true);
        setTimeout(() => {
          this.href("/onlineLearning", { courseId: this.currentExamCourseId });
        }, 500)
      }
    },
    getScorePercent(score, total) {
      return ((Number(score) / Number(total)) * 100).toFixed(0);
    },
    getNewExamRecordInfo() {
      this.$Api.exam.getNewExamRecordInfo(this.recordId).then(res => {
        this.examInfo = res.data.data;
        this.getPaperCount();
      }).catch(() => { })
    },
    getPaperCount() {
      this.$Api.exam.getPaperCount(this.examInfo.paperId).then(res => {
        this.testPaperInfo = res.data.data;
        this.getPaperRecordCount();
        if (!this.$Tools.empty(this.loading)) {
          this.loading.close();
          this.loading = {};
        }
      }).catch(() => {
        if (!this.$Tools.empty(this.loading)) {
          this.loading.close();
          this.loading = {};
        }
      })
    },
    getPaperRecordCount() {
      this.$Api.exam.getPaperRecordCount(this.examInfo.paperId).then(res => {
        this.testPaperInfo.startTime = res.data.data[0]?.startTime;
        this.testPaperInfo.endTime = res.data.data[0]?.endTime;
        this.testPaperInfo.isCorrect = res.data.data[0]?.isCorrect;
        this.testPaperInfo.answerSection = (new Date(res.data.data[0]?.endTime) - new Date(res.data.data[0]?.startTime)) / 1000;
      }).catch(() => { })
    },
    // 测评作答记录
    getTestPaperRecord() {
      this.$Api.testPaper.getTestPaperRecord(this.recordId).then(res => {
        this.examInfo = res.data.data;
        if (!this.$Tools.empty(this.loading)) {
          this.loading.close();
          this.loading = {};
        }
      }).catch(() => {
        if (!this.$Tools.empty(this.loading)) {
          this.loading.close();
          this.loading = {};
        }
      })
    },
    // 测评统计
    testPaperCount() {
      this.$Api.testPaper.testPaperCount(this.recordId).then(res => {
        this.testPaperInfo = res.data.data;
        if (!this.$Tools.empty(this.loading)) {
          this.loading.close();
          this.loading = {};
        }
      }).catch(() => {
        if (!this.$Tools.empty(this.loading)) {
          this.loading.close();
          this.loading = {};
        }
      })
    },
    goRecordPaper() {
      this.href("/examRecordPaper", { recordId: this.recordId, testPaperType: this.testPaperType });
    },
    goExamAnalysis() {
      this.$Api.testPaper.getTestPaperReportStatus(this.recordId).then(res => {
        if (res.data.data) {
          this.href("/examAnalysis", { recordId: this.recordId, testPaperType: this.testPaperType });
        } else {
          this.$Dialog.toast("报告正在生成中，请稍后查询", { type: 'warning' });
        }
      }).catch(() => { })
      // this.href("/examAnalysis", { recordId: this.recordId, testPaperType: this.testPaperType });
    }
  },
};
</script>

<style lang="scss" scoped>
.exam_start {
  width: 100%;
  background: #f3f3f3;

  .exma_title {
    width: $pageMainWidth;
    color: rgba(144, 144, 144, 1);

    .exam_result {
      color: rgba(48, 48, 48, 1);
    }
  }

  .exam_info {
    min-height: 774px;
    background: #ffffff;
    border-radius: 16px;

    .organization_info {
      height: 90px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      padding-left: 25px;
      color: RGBA(17, 17, 17, 1);
      box-sizing: border-box;
      font-family: monospace;
      font-weight: bold;
      font-size: 18px;

      .gjkc_index_logo {
        width: 50px;
        height: 50px;
      }
    }
  }

  .grade_analysis {
    .grade_title {
      font-size: 20px;
      color: #303030;
      font-weight: 500;
    }

    .exam_result {
      .exam_name {
        font-weight: 500;
        font-size: 18px;
        color: #111111;
      }

      .exam_desc {
        font-size: 14px;
        color: #909090;
      }

      .split_line {
        width: 80%;
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
      }

      .exam_response {
        width: 75%;

        .exam_response_one {
          font-size: 16px;
          color: #909090;

          .response_value {
            color: #303030;
          }
        }
      }

      .exam_result_box {
        width: 80%;

        .exam_result_one {
          width: 45%;
          height: 60px;
          background: #FAFAFA;
          border-radius: 11px;
          font-size: 14px;
          color: #303030;

          .exam_detail_icon {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }

  .empty_box {
    min-height: 600px;
    text-align: center;
    font-size: 15px;
    color: #606060;

    .moe_empty_bg_img {
      width: 313px;
      height: 260px;
      margin-top: 120px;
    }
  }
}
</style>
